import '@/lib/firebase/firebaseClient';  // Import this first
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'

try {
  const container = document.getElementById('root')
  
  if (!container) {
    throw new Error('Root element not found')
  }

  const root = createRoot(container)
  
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
  )
} catch (error) {
  console.error('Error mounting application:', error)
}
